<template>
  <div class="h-full">
    <calendar-view
      :date-classes="holidays()"
      :display-period-uom="calendarView"
      :events="formattedEvents"
      :show-date="showDate"
      :starting-day-of-week="1"
      @click-date="$emit('dateClick', $event)"
      @click-event="$emit('itemClick', $event)"
      class="theme-default"
      event-top="2em"
      ref="calendar">
      <div class="flex relative my-5 justify-between my-2 w-full" slot="header">
        <slot></slot>
        <div class="flex mx-auto">
          <base-button @click="toggleDate(-1)" button="filled" class="px-2 py-2 rounded-full"
                       icon="arrow-left"></base-button>
          <div class="text-xl font-semibold mx-2 self-center">{{ showDate | date('MMMM YYYY') }}</div>
          <base-button @click="toggleDate(1)" button="filled" class="px-2 py-2 rounded-full"
                       icon="arrow-right"></base-button>
        </div>
      </div>
    </calendar-view>
    <div class="mt-2">
      <BaseIcon class="text-sm" name="asterisk"></BaseIcon>
      <span class="mx-1">{{ $t('calendar.asterisk') }}</span>
    </div>
  </div>
</template>

<script>
  import {CalendarView} from 'vue-simple-calendar'
  import * as moment from 'moment'

  export default {
    name: "Calendar",
    props: {
      events: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      showDate: new Date(),
      monthView: true
    }),
    components: {
      CalendarView,
    },
    methods: {
      toggleDate (d) {
        this.showDate = this.$refs.calendar.getIncrementedPeriod(d);
        this.$emit('toggle', this.showDate);
        this.mountEventDots()
      },
      mountEventDots () {
        this.$nextTick(() => {
          document.querySelectorAll('.cv-event').forEach((event) => {
            let dot = document.createElement('div');
            dot.className += 'event-dot';
            event.appendChild(dot)
          })
        })
      },
      getClass (event, currentClass) {
        const defaultClass = 'hr-sys-has-event holiday';
        if (currentClass && currentClass !== defaultClass) {
          return currentClass;
        }
        if (event['has_overtime']) {
          return 'hr-sys-has-event overtime';
        }
        if (event['has_undertime']) {
          return 'hr-sys-has-event undertime';
        }
        return defaultClass
      },
      holidays () {
        let holidays = {};
        this.events.forEach(event => {
          holidays[moment(event.date).format("YYYY-MM-DD")] = this.getClass(event, holidays[moment(event.date).format("YYYY-MM-DD")]);
        });
        return holidays
      }
    },
    computed: {
      formattedEvents () {
        let newEvents = [];
        this.events.forEach(event => {
          let {id, name, date} = event;
          let newEvent = {};
          newEvent.id = id;
          newEvent.title = name;
          newEvent.startDate = date;
          newEvents.push(newEvent)
        });
        return newEvents
      },
      calendarView () {
        let view = this.monthView ? 'month' : 'week';
        this.mountEventDots();
        return view
      },
    },
    mounted () {
      this.mountEventDots()
    },
    watch: {
      events: {
        deep: true,
        handler () {
          this.mountEventDots()
        }
      },
    }
  }
</script>
